import React, { useState, useEffect } from 'react';
import Modal from 'jd-library/Modal';
import styles from './confirm-delete.scss';
import Button from '../../common/Button/Button';
import { useSelector } from 'react-redux';


const ApproveProdModal = props => {
    const [prodName, setProdName] = useState(props?.productData?.productName)
    const [showLoader, setShowLoader] = useState(false)
    const profileObject = useSelector(state => state.session?.profileObject)

    useEffect(() => {
        if(prodName && prodName.length > 100){
            let truncatedName = props?.productData?.productName.substr(0, 100) + '...';
            setProdName(truncatedName);
        }
    }, [])
    let textlabel = 'Product';
    if(props?.productData?.type == 'service' && !props.isMultiSelect || props.serviceProfile){
        textlabel = 'Service';
    }
    const productCount = props.isAllSelected ? props.approvalPendingCount : props.productsLength;
    return (
        <div className={styles['add-edit-block-modal']}>
            <Modal
                settings={{
                    modalId: 'confirm-delete-modal',
                    variant: 'action'
                }}
                onHidden={() => props.onModalClose()}
            >
                <Modal.CloseIcon />
                <Modal.Header>
                    <span className={styles['title']}>{props.isMultiSelect && props.productsLength > 1 ? `Approve ${profileObject?.PluralLabelWithSpace}` : ('Approve '+profileObject?.SingleLabelWithSpace)}</span>
                </Modal.Header>
                <Modal.Body className={styles['modal-body']}>
                    <div className={styles['subtitle']}>
                        Are you sure you want to approve {props.isMultiSelect && props.productsLength > 1 ? `${productCount} ${profileObject?.PluralLabelWithSpace}` : <span className={styles['bold-text']}>{prodName}</span>}?
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className={styles['button-wrapper']}>
                        <Button 
                            size='lg' 
                            clickHandler={()=>{
                                setShowLoader(true)
                                if(!showLoader)
                                {
                                    window.history.back();
                                    props.onApprove(()=>{
                                        setShowLoader(false);
                                    });                                 
                                }
                            }} 
                            showLoader={showLoader}
                            className={`${styles['delete-btn']}`}
                        >
                                {props.isMultiSelect && props.productsLength > 1 ?`Approve ${profileObject?.PluralLabelWithSpace}`: `Approve ${profileObject?.SingleLabelWithSpace}`}
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default ApproveProdModal;

